import React from 'react'
import { DefaultLayout } from '../../layouts'
import { AlertEmpty, Container, SimplePageHeader, StatusHandler } from '../../components'
import { RelatedPosts, Sidebar, HeadComponent } from './components'
import { useHistory, useLocation } from 'react-router-dom'
import { MainContent } from './components/main-content'
import { useDispatch, useSelector } from 'react-redux'
import { fetchBlog } from '../../features/blog/slice'
import { toast } from 'react-toastify'
import { isValidID } from '../../utils'
import ContentVisibilityFilter from '../../features/visibility/components/content-filter'

const BlogDetail = ({ match }) => {
  const location  = useLocation()
  const dispatch = useDispatch()
  const history = useHistory()
  const isNotExist = location.search.includes('exist=false')
  const id = match.params.id
  const { data:blog, status, error } = useSelector(state => state.blog)

  React.useEffect(() => {
    if(isValidID(id)){
      dispatch(fetchBlog(id))
    } else {
      toast.error('Invalid ID.')
      history.push('/blog')
    }
    // eslint-disable-next-line
  }, [id])

  return (
    <DefaultLayout>
      <SimplePageHeader noPadding/>

      <ContentVisibilityFilter data={blog}>
        <StatusHandler
          status={status}
          error={error}
          onRetry={() => dispatch(fetchBlog(id))}
        >
          {
            blog ? (
              <Container className="pt-5 pb-10 lg:pt-20 lg:pb-20" color="#f5f5f5">
                <div className="lg:hidden">
                  <HeadComponent isNotExist={isNotExist} data={blog}/>
                </div>
                <div className="flex flex-wrap -mx-4">
                  <div className="w-full lg:w-8/12 px-4 order-2 lg:order-1">
                    <div className="hidden lg:block">
                      <HeadComponent isNotExist={isNotExist} data={blog}/>
                    </div>
                    <MainContent blog={blog}/>
                  </div>
                  <div className="w-full lg:w-3/12 lg:ml-auto px-4 order-1 lg:order-2">
                    <Sidebar />
                  </div>
                </div>
              </Container>
            ) : (
              <Container className="py-10 lg:py-20 text-center">
                <AlertEmpty />
              </Container>
            )
          }
        </StatusHandler>
      </ContentVisibilityFilter>

      <RelatedPosts />
    </DefaultLayout>
  )
}

export { BlogDetail }
